import React, { useEffect } from 'react';

import { useHistory, useLocation } from 'react-router-dom';
import { useRecoilValue, useRecoilState } from 'recoil';
import { isHeaderBlackState, isModalOnState } from '../../store/atoms';
import Burger from 'react-css-burger';

import styled from 'styled-components';

export default function HeaderWithoutLang() {
  const history = useHistory();
  const location = useLocation().pathname;
  const isHeaderBlack = useRecoilValue(isHeaderBlackState);
  const [isModalOn, setIsModalOn] = useRecoilState(isModalOnState);

  const handleClick = (location = '') => {
    history.push(`/${location}`);
    if (isModalOn) setIsModalOn(false);
  };

  const handleModal = () => {
    if (isModalOn) setIsModalOn(false);
    if (!isModalOn) setIsModalOn(true);
  };

  const handleModalClose = e => {
    const isClickedInside = e.target.closest('.modal');
    const isClickedCloseBtn = e.target.closest('.close');

    if (!isClickedInside && !isClickedCloseBtn) {
      setIsModalOn(false);
    }
  };

  useEffect(() => {
    if (isModalOn) document.body.style.overflow = 'hidden';
    if (!isModalOn) document.body.style.overflow = 'unset';
    window.addEventListener('click', handleModalClose);
    return () => {
      window.removeEventListener('click', handleModalClose);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOn]);

  return (
    <StyledNavbar
      isHeaderBlack={isHeaderBlack}
      location={location}
      onClick={handleModalClose}
    >
      <StyledContentsContainer>
        <StyledLogoContainer>
          <StyledLogo
            alt="intelliquant logo"
            src={
              !isHeaderBlack || isModalOn
                ? 'images/logo/black/logo-black.svg'
                : 'images/logo/white/logo-white.svg'
            }
            onClick={() => {
              handleClick();
            }}
          />
        </StyledLogoContainer>
        <StyledBtnContainer>
          <StyledCategoryContainer>
            <StyledStudioBtn>
              <a
                href="https://www.intelliquant.ai/"
                target="_blank"
                rel="noreferrer"
              >
                스튜디오
                <img alt="right path" src="images/right_path/path-2@3x.png" />
              </a>
            </StyledStudioBtn>
            <StyledAboutBtn
              onClick={() => {
                handleClick('about');
              }}
              location={location}
            >
              회사소개
            </StyledAboutBtn>
            <StyledTeamBtn
              onClick={() => {
                handleClick('team');
              }}
              location={location}
            >
              팀
            </StyledTeamBtn>
            <StyledNewsBtn
              onClick={() => {
                handleClick('news');
              }}
              location={location}
            >
              뉴스
            </StyledNewsBtn>
          </StyledCategoryContainer>
        </StyledBtnContainer>
        <StyledBurger className="close">
          <Burger
            active={isModalOn}
            burger="slider"
            color={!isHeaderBlack || isModalOn ? 'black' : 'white'}
            scale={0.6}
            onClick={handleModal}
          />
        </StyledBurger>
      </StyledContentsContainer>
      <StyledMobileModal
        isModalOn={isModalOn}
        setOff={setIsModalOn}
        className="modal"
      >
        <StyledMobileCategoryContainer>
          <StyledStudioBtn>
            <a
              href="https://www.intelliquant.ai/"
              target="_blank"
              rel="noreferrer"
            >
              스튜디오
              <img alt="right path" src="images/right_path/path-2@3x.png" />
            </a>
          </StyledStudioBtn>
          <StyledAboutBtn
            onClick={() => {
              handleClick('about');
            }}
            location={location}
          >
            회사소개
          </StyledAboutBtn>
          <StyledTeamBtn
            onClick={() => {
              handleClick('team');
            }}
            location={location}
          >
            팀
          </StyledTeamBtn>
          <StyledNewsBtn
            onClick={() => {
              handleClick('news');
            }}
            location={location}
          >
            뉴스
          </StyledNewsBtn>
        </StyledMobileCategoryContainer>
      </StyledMobileModal>
      {isModalOn && <StyledMobileModalBackground />}
    </StyledNavbar>
  );
}

const StyledNavbar = styled.header`
  background-color: ${({ theme, isHeaderBlack }) =>
    isHeaderBlack ? theme.colors.black : theme.colors.pureWhite};
  position: fixed;
  top: 0;
  width: 100%;
  transition: background-color 0.3s;
  z-index: 10;
  box-shadow: ${({ isHeaderBlack }) =>
    !isHeaderBlack && `0 2px 10px 0 rgba(240, 240, 240, 0.5);`};
`;

const StyledContentsContainer = styled.div`
  ${({ theme }) => theme.flex('row', 'space-between')}
  margin: 0 auto;
  max-width: 1340px;
  padding: 19px 30px;

  button:last-child {
    margin: 0;
    padding: 0;
  }

  ${({ theme }) => theme.mobile`
  padding: 15px 31px;
  `}
`;

const StyledLogoContainer = styled.div`
  ${({ theme: { flex } }) => flex()};
`;

const StyledLogo = styled.img`
  width: 217px;
  transition: 0.3s opacity;
  z-index: 10;
  height: 46px;
  object-fit: cover;

  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  ${({ theme }) => theme.mobile`
    width: 141px;
  `}
`;

const StyledCategoryContainer = styled.nav`
  button:last-child {
    margin-right: 0;
  }
`;

const StyledBtnContainer = styled.div`
  ${({ theme }) => theme.flex()}

  ${({ theme }) => theme.mobile`
    display: none;
  `}
`;

const StyledBtn = styled.button`
  margin-right: 62px;
  color: ${({ theme }) => theme.colors.grey3};
  font-size: ${({ theme }) => theme.pixelToRem(20)};
  font-weight: 400;
  transition: 0.3s all;

  &:hover {
    cursor: pointer;
    opacity: 0.8;

    &:active {
      opacity: 0.7;
    }
  }
`;

const StyledStudioBtn = styled(StyledBtn)`
  a {
    display: inline-block;
  }

  img {
    width: 11px;
    position: relative;
    margin-left: 10px;
    top: 1px;
  }
`;

const StyledAboutBtn = styled(StyledBtn)`
  color: ${({ theme, location }) => {
    if (location === '/about') {
      return theme.colors.green;
    }
    return theme.colors.grey3;
  }};
`;

const StyledTeamBtn = styled(StyledBtn)`
  color: ${({ theme, location }) => {
    if (location === '/team') {
      return theme.colors.green;
    }
    return theme.colors.grey3;
  }};
`;

const StyledNewsBtn = styled(StyledBtn)`
  color: ${({ theme, location }) => {
    if (location === '/news') {
      return theme.colors.green;
    }
    return theme.colors.grey3;
  }};
`;

const StyledMobileCategoryContainer = styled.div`
  ${({ theme }) => theme.flex('column', 'flex-start', 'flex-start')}
  margin-top: 60px;

  button {
    margin-bottom: 32px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const StyledMobileModalBackground = styled.div`
  display: none;
  position: absolute;
  width: 100%;
  height: 100vh;
  background-color: black;
  opacity: 0.7;

  ${({ theme }) => theme.mobile`
    display: block;
  `}
`;

const StyledMobileModal = styled.div`
  display: none;
  position: absolute;
  width: 100%;
  padding: 19px 32px 102px;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  top: 0;
  right: 0;
  z-index: 5;
  transform: ${({ isModalOn }) => {
    if (isModalOn) {
      return 'none';
    }
    return 'translateX(100%)';
  }};

  ${({ theme }) => theme.mobile`
    display: block;
  `};
  transition: 0.3s transform;
`;

const StyledBurger = styled.div`
  display: none;
  z-index: 100;

  .burger_hamburger-inner__14XT2::before {
    width: 25px;
    right: 0;
  }
  .burger_hamburger-inner__14XT2::after {
    width: 12.5px;
    right: 0;
  }

  .burger_is-active__3Yxiv .burger_hamburger-inner__14XT2::before,
  .burger_is-active__3Yxiv .burger_hamburger-inner__14XT2::after {
    width: 40px;
  }

  ${({ theme }) => theme.mobile`
    display: block;
  `}

  button {
    span {
      span,
      span::before,
      span::after {
        transition-duration: 0.3s;
      }
    }
  }
`;
